import request from '@/utils/request';
//用户登录
export function userLogin(data = {}) {
    return request({
        url: '/api/user/businessLogin',
        method: 'post',
        data
    })
}